export const EMPLOYEE20_PROMO_CODE = 'EMPLOYEE20'
export const EMPLOYEE5_PROMO_CODE = 'EMPLOYEE5'

export const EMPLOYEE_PROMO_CODES = new Set([EMPLOYEE20_PROMO_CODE, EMPLOYEE5_PROMO_CODE])
